import api from '@/utils/http'

/**
 功能：保存角色
 time: 2025-38-02 16:38:38
 **/
export function saveUser(data) {
    return api.post('/admin/admin/setUser', data)
}

/**
 功能：
 time: 2026/1/7 15:47
 **/
export function getUserInfo() {
    return api.get('/admin/admin/getInfo')
}

/**
 功能：
 time: 2026/3/16 11:25
 **/
export function getAccount(admin_id) {
    return api.post('/admin/admin/getAccount', {admin_id: admin_id})
}

/**
 功能：
 time: 2026/1/7 16:08
 **/
export function savePass(data) {
    return api.post('/admin/admin/setPass', data)
}
